import * as React from 'react';
import { Props } from 'react';

import './DialogView.scss';
import i18next from 'i18next';

interface CurrenciesDialogViewProps extends Props<CurrenciesDialogView> {

}

export class CurrenciesDialogView extends React.Component<CurrenciesDialogViewProps> {
    render() {
        return (
            <div className='dialog-container'>
                <div className='dialog-client-message'>
                    {i18next.t('dollar_rate')}
                </div>
                <div className='clearfix' />
                <div className='dialog-bot-message'>
                    {i18next.t('dollar_rate_answer')}
                </div>
                <div className='clearfix' />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/CleverBot/Home/Dialogs/CurrenciesDialogView.tsx